import { getToken } from './localstorage';
import fileDownload from 'js-file-download';

export const downloadFile = (url, fileName) => {
  const token = getToken();
  const headers = { 'Authorization': `Bearer ${token}` };

  fetch(url, { headers })
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    });
};


export const downloadReport = (url, fileName, params) => {
  const token = getToken();
  fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json, text/plain',
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(params),
  })
    .then((response) => response.blob())
    .then((blob) => {
      fileDownload(blob, fileName);
    });
};